import { TFunction } from "i18next";

const PAYMENT_STATUS_KEYS: Record<string, string> = {
  paid: "invoicesPayments.paid",
  success: "invoicesPayments.paid",
  completed: "invoicesPayments.paid",
  pending: "status.pending",
  overdue: "invoicesPayments.overdue",
  rejected: "invoicesPayments.rejected",
  failed: "status.failed",
  partial: "invoicesPayments.remaining",
};

/** Maps API payment status strings to localized labels. */
export function localizePaymentStatus(
  status: string | number | null | undefined,
  t: TFunction
): string {
  const raw = String(status ?? "").trim();
  if (!raw) return "-";

  const key = PAYMENT_STATUS_KEYS[raw.toLowerCase()];
  return key ? t(key) : raw;
}
